import {useEffect, useState} from 'react'
import {getListAuthorizedUsers, homeListContentStatistics} from '../modules/auth/core/_requests'
import {useLang} from '../../_metronic/i18n/Metronici18n'
import {useIntl} from 'react-intl'
import {useAuth} from '../modules/auth'
import {AxiosError} from 'axios'
import {UsersListLoading} from '../modules/apps/user-management/users-list/components/loading/UsersListLoading'
import clsx from 'clsx'
import {TablesWidget122} from '../../_metronic/partials/widgets/tables/TablesWidget122'
import {contentTypeList, contentViewType} from '../../IOTFYEDUTypeList'

function ContentLog() {
  const lang = useLang()
  const intl = useIntl()
  const {currentUser} = useAuth()

  const [contentLogData, setContentLogData] = useState<any>([])
  const [userId, setUserId] = useState<number>(currentUser?.id || 0)
  const [userList, setUserList] = useState([])
  const [startDate, setStartDate] = useState(new Date())
  const [finishDate, setFinishDate] = useState(new Date())
  const [viewType, setViewType] = useState(0)
  const [contentType, setContentType] = useState(0)
  const [loading, setLoading] = useState<boolean>(false)
  const [listing, setListing] = useState<boolean>(false)

  useEffect(() => {
    getUserList()
  }, [])

  useEffect(() => {
    if (listing) {
      getContentStatistics()
      setListing(false)
    }
  }, [listing])

  /* useEffect(() => {
    getContentStatistics()
  }, [startDate, finishDate, userId, viewType, contentType])*/

  const getContentStatistics = async () => {
    setLoading(true)
    try {
      const {data} = await homeListContentStatistics(
        0,
        userId,
        0,
        startDate,
        finishDate,
        viewType,
        contentType,
        lang
      )
      setContentLogData(data)
    } catch (error) {
      setContentLogData([])
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const getUserList = async () => {
    try {
      const {data} = await getListAuthorizedUsers()
      setUserList(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  const GetDataTableItem = ({data}) => {
    const [tableData, setTableData] = useState<any>(data || [])
    let itemsPerPage = 10
    const [currentPage, setCurrentPage] = useState(1)

    const indexOfLastItem = currentPage * itemsPerPage
    const indexOfFirstItem = indexOfLastItem - itemsPerPage
    const currentItems = tableData.slice(indexOfFirstItem, indexOfLastItem)
    const totalPages = Math.ceil(tableData.length / itemsPerPage)

    const columns = ['ID', 'USER', 'CONTENT TYPE', 'CONTENT TITLE', 'DURATION']
    const [sorting, setShorting] = useState({column: 'TIME', order: 'desc'})

    const sortTable = (newSorting) => {
      setShorting(newSorting)
    }

    useEffect(() => {
      const sortArray = (type: string) => {
        const types = {
          ID: 'id',
          USER: 'userId',
          'CONTENT TYPE': 'contentType',
          'CONTENT TITLE': 'contentTitle',
          DURATION: 'duration',
        }
        const sortProperty = types[type]

        const sorted = [...tableData].sort((a, b) => {
          if (sorting.order === 'asc') {
            return a[sortProperty] > b[sortProperty] ? 1 : -1
          } else {
            return a[sortProperty] < b[sortProperty] ? 1 : -1
          }
        })

        return sorted
      }
      setTableData(sortArray(sorting.column))
    }, [sorting])

    return (
      <div className='card'>
        <TablesWidget122
          className='mb-5 mb-xl-8'
          data={currentItems}
          excelData={contentLogData}
          columns={columns}
          sorting={sorting}
          sortTable={sortTable}
        />
        <div className='me-5'>
          <PaginationComponent
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />
        </div>
      </div>
    )
  }

  const optionViewTypeList = contentViewType.map((item: any) => ({
    value: item.id,
    label: String(item.name),
  }))

  const optionContentTypeList = contentTypeList.map((item: any) => ({
    value: item.id,
    label: String(item.name),
  }))

  return (
    <div className='row g-5 gx-xl-10 mt-lg-n16 mt-2'>
      <div className='col-xxl-12'>
        <div className='card card-flush p-5 mb-5'>
          {/* 👇 Start Date  👇 */}
          <div className='mb-10 row'>
            <div className='col'>
              <label className='form-label fw-bold'>
                {intl.formatMessage({id: 'REPORTPAGE.START_DATE'})}
              </label>
              <input
                type='date'
                className='form-control '
                placeholder='Expire Date'
                value={startDate ? new Date(startDate).toISOString().split('T')[0] : ''}
                onChange={(e) => {
                  const selectedDate = e.target.value
                  const date = new Date(selectedDate)
                  setStartDate(date)
                }}
              />
            </div>
            {/* 👆 Start Date  👆 */}
            {/* 👇 Finish Date  👇 */}
            <div className='col'>
              <label className='form-label fw-bold'>
                {intl.formatMessage({id: 'REPORTPAGE.FINISH_DATE'})}
              </label>
              <input
                type='date'
                className='form-control '
                placeholder='Expire Date'
                value={finishDate ? new Date(finishDate).toISOString().split('T')[0] : ''}
                onChange={(e) => {
                  const selectedDate = e.target.value
                  const date = new Date(selectedDate)
                  setFinishDate(date)
                }}
              />
            </div>
          </div>
          {/* 👆 Finish Date  👆 */}
          <div className='mb-10 row'>
            {/* 👇 View Type  👇 }
     
            <div className='col'>
              <label className='form-label fw-bold'>
                {intl.formatMessage({id: 'REPORTPAGE.VIEW_TYPE'})}
              </label>
              <select
                className='form-select form-select-solid'
                data-kt-select2='true'
                data-placeholder='Select option'
                data-allow-clear='true'
                value={viewType}
                onChange={(e) => setViewType(Number(e.target.value))}
              >
                {optionViewTypeList.map((item: any, index: number) => (
                  <option key={index} value={item.value}>
                    {intl.formatMessage({
                      id: `REPORTPAGE.${String(item.label).toLocaleUpperCase().replace(' ', '_')}`,
                    })}
                  </option>
                ))}
              </select>
            </div>

            { 👆 View Type  👆 */}
            {/* 👇 Select User  👇 */}
            <div className='col'>
              <label className='form-label fw-bold'>
                {intl.formatMessage({id: 'REPORTPAGE.SELECTUSER'})}
              </label>

              <select
                className='form-select form-select-solid'
                data-kt-select2='true'
                data-placeholder='Select option'
                data-allow-clear='true'
                value={userId}
                onChange={(e) => setUserId(Number(e.target.value))}
              >
                <option value={0}>{intl.formatMessage({id: 'REPORTPAGE.ALLUSERS'})}</option>
                {userList.map((item: any, index: number) => (
                  <option key={index} value={item.id}>
                    {item.fullName}
                  </option>
                ))}
              </select>
            </div>
            {/* 👆 Select User  👆 */}
            {/* 👇 Content Type  👇 */}
            <div className='col'>
              <label className='form-label fw-bold'>
                {intl.formatMessage({id: 'REPORTPAGE.CONTENT_TYPE'})}
              </label>
              <select
                className='form-select form-select-solid'
                data-kt-select2='true'
                data-placeholder='Select option'
                data-allow-clear='true'
                value={contentType}
                onChange={(e) => setContentType(Number(e.target.value))}
              >
                {optionContentTypeList.map((item: any, index: number) => (
                  <option key={index} value={item.value}>
                    {intl.formatMessage({
                      id: `REPORTPAGE.${String(item.label).toLocaleUpperCase().replace(' ', '_')}`,
                    })}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {/* 👆 Content Type  👆 */}
          {/* 👇 Select User  👇 }
          <div className='mb-10 w-50'>
            <label className='form-label fw-bold'>
              {intl.formatMessage({id: 'REPORTPAGE.SELECTUSER'})}
            </label>

            <select
              className='form-select form-select-solid'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              value={userId}
              onChange={(e) => setUserId(Number(e.target.value))}
            >
              <option value={0}>{intl.formatMessage({id: 'REPORTPAGE.ALLUSERS'})}</option>
              {userList.map((item: any, index: number) => (
                <option key={index} value={item.id}>
                  {item.fullName}
                </option>
              ))}
            </select>
          </div>
          {👆 Select User  👆 */}
          {/* 👇 Listing Button  👇 */}
          <div className='d-flex justify-content-end'>
            <button type='button' className='btn btn-primary' onClick={() => setListing(true)}>
              List
            </button>
          </div>
          {/* 👆 Listing Button   👆 */}
        </div>
        {loading ? (
          <UsersListLoading />
        ) : (
          <>
            <GetDataTableItem data={contentLogData} />
          </>
        )}
      </div>
    </div>
  )
}

export default ContentLog

const PaginationComponent = ({currentPage, setCurrentPage, totalPages}) => {
  const intl = useIntl()

  const handleClick = (type: any) => {
    if (type === 'prev') {
      setCurrentPage(currentPage - 1)
    } else if (type === 'next') {
      setCurrentPage(currentPage + 1)
    }
  }

  const renderPageNumbers = () => {
    const pageNumbers: any[] = []
    const pageLimit = 6 // Varsayılan sayfa sınırı
    const maxLeft = currentPage - Math.floor(pageLimit / 2)
    const maxRight = currentPage + Math.floor(pageLimit / 2)
    let ellipsisLeft = false
    let ellipsisRight = false

    for (let i = 1; i <= totalPages; i++) {
      let isActive = currentPage === i

      if (i === 1 || i === totalPages || (i >= maxLeft && i <= maxRight)) {
        pageNumbers.push(
          <li
            key={i}
            className={clsx('page-item', {
              active: isActive,
            })}
          >
            <a
              className={clsx('page-link', {})}
              style={{cursor: 'pointer'}}
              onClick={() => setCurrentPage(i)}
            >
              {i}
            </a>
          </li>
        )
      } else if (i < maxLeft && !ellipsisLeft && maxLeft > 2) {
        pageNumbers.push(
          <li key={i} className={clsx('page-item', {})}>
            <a className={clsx('page-link', {})}>...</a>
          </li>
        )
        ellipsisLeft = true
      } else if (i > maxRight && !ellipsisRight && maxRight < totalPages - 1) {
        pageNumbers.push(
          <li key={i} className={clsx('page-item', {})}>
            <a className={clsx('page-link', {})}>...</a>
          </li>
        )
        ellipsisRight = true
      }
    }

    return pageNumbers
  }

  return (
    <div className='row'>
      <div className='mb-5 pe-5 d-flex align-items-center justify-content-center justify-content-md-end'>
        <ul className='pagination'>
          <li
            className={clsx('page-item', {
              disabled: currentPage === 1,
            })}
          >
            <a
              onClick={() => handleClick('prev')}
              style={{cursor: 'pointer'}}
              className='page-link'
            >
              {intl.formatMessage({id: 'REPORTPAGE.PREV'})}
            </a>
          </li>
          {renderPageNumbers()}
          <li
            className={clsx('page-item', {
              disabled: currentPage === totalPages,
            })}
          >
            <a
              onClick={() => handleClick('next')}
              style={{cursor: 'pointer'}}
              className='page-link'
            >
              {intl.formatMessage({id: 'REPORTPAGE.NEXT'})}
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}
